// extracted by mini-css-extract-plugin
export default {"hasCashPayments":"RevenueOfEvent_hasCashPayments__Gy6yN"};